import { defineMessages } from '@transcend-io/internationalization';

export const displayDataMessages = defineMessages(
  'pc-core-components.DisplayData.displayData',
  {
    fileTooLarge: {
      defaultMessage: 'File is Too Large to Display',
    },
    unknownFileType: {
      defaultMessage: 'Cannot display this file format',
    },
    noAudio: {
      defaultMessage: 'Your browser does not support the audio element.',
    },
    noVideo: {
      defaultMessage: 'Your browser does not support the video element.',
    },
  },
);
